import { Provider, useDispatch, useSelector } from "react-redux";
import Router from "./routes/Router";
import { store, persistor, clearPersistedData } from "./store/configureStore";
import { PersistGate } from "redux-persist/integration/react";
import axios from "axios";
import { deAuthenticate } from "./store/reducers/authSlice";
import LoaderOverlay from "./components/Loader";
import ErrorModal from "./components/Alerts/ErrorModal/index";
import SuccessModal from "./components/Alerts/SuccessModal/index";
import { ToastContainer } from "react-toastify";
import { useEffect } from "react";
import { PURGE_Brand } from "./store/reducers/brandReducer";
import UpdateDetector from "./components/UpdateDetector";

function App() {
  const dispatch = useDispatch();
  const ee_device_id = localStorage.getItem("ee-device-id");
  axios.defaults.headers.common["X-EE-Device-Id"] = ee_device_id;

  let ee_session_token = localStorage.getItem("ee-session-token");
  if (ee_session_token) {
    axios.defaults.headers.common["X-SESSION-TOKEN"] = ee_session_token;
  }

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      const url = error?.config?.url || "";
      const isAuthUrl =
        url.includes("/auth/admin/login/") ||
        url.includes("/auth/admin/mfa/") ||
        url.includes("/user/profile/");

      const isPermissionDenied =
        error?.response?.data?.detail ===
        "You do not have permission to perform this action.";

      if (
        (error?.response?.status === 401 || (error?.response?.status === 403 && !isPermissionDenied)) &&
        !isAuthUrl
      ) {
        const currentPath = window.location.pathname + window.location.search;
        if (currentPath !== "/signin" && !currentPath.startsWith("/signin")) {
          dispatch(deAuthenticate());
          dispatch(PURGE_Brand());

          localStorage.clear();
          sessionStorage.clear();

          sessionStorage.setItem("redirectAfterLogin", currentPath);

          window.location.href = "/signin";
          clearPersistedData();
        }
      }
      return Promise.reject(error);
    }
  );
  useEffect(() => {
    const isProduction = window.location.hostname === "super.equityedge.co.uk";

    if (isProduction) {
      console.log = () => {}; // Silencing console logs in production
    }
  }, []);

  const selectedBrand = useSelector((state) => state.brand.selectedBrand);

  useEffect(() => {
    document.body.classList.remove(
      "equity_edge",
      "futures_edge",
      "crypto_edge"
    );
    document.body.classList.add(selectedBrand.brand); // Use `.brand`
  }, [selectedBrand.brand]); // Depend on `selectedBrand.brand`
  useEffect(() => {
    const html = document.documentElement;
    html.classList.remove("equity_edge", "futures_edge", "crypto_edge");
    html.classList.add(selectedBrand.brand);
  }, [selectedBrand.brand]);
  return (
    <div
      className={`App ${
        selectedBrand.brand === "crypto_edge" && "crypto_edge"
      }`}
    >
      <ToastContainer />
      <UpdateDetector />
      <Router />
      <SuccessModal />
      <ErrorModal />
    </div>
  );
}

export default App;
